<template>
  <div class="v-content-renderer">
    <div
      v-for="(contentBlock, index) in blocks"
      :key="blockKey(contentBlock, index)"
      class="component-container"
    >
      <component
        :is="resolveContentComponent(contentBlock)"
        class="content-component"
        v-bind="getContentBindings(contentBlock, showAnswers)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentBlock } from './renderer-base/contentBlock.types'
import {
  getContentBindings,
  resolveContentComponent,
} from './renderer-base/useContentElements'

interface Props {
  content: ContentBlock[]
  /** Підсвітка правильних відповідей для тестів (типи office 7, 8, 9). */
  showAnswers?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showAnswers: false,
})

const blocks = computed(() => props.content ?? [])

function blockKey(block: ContentBlock, index: number): string | number {
  const id = block.id
  if (id !== undefined && id !== null && String(id)) return String(id)
  return index
}
</script>

<style scoped>
.v-content-renderer {
  display: inline-flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  font-family: 'PT Sans', var(--font-inter), sans-serif;
  font-size: 19px;
  line-height: 1.7;
  color: #374151;
}

.component-container {
  width: 100%;
}

.content-component {
  width: 100%;
}
</style>
